module.exports = __webpack_public_path__ + "cf0d33ca389e8c13fe73451d7bff0bd5.MP3";